import { model } from "@atlassiansox/bxp-content-framework";

export const uiSocialLoginSignupButton = model({
    name: "Ui Social Login Signup Button",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        providerName: {
            name: "Provider name",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    in: ["google", "microsoft", "apple", "slack"]
                }
            ],
            disabled: false,
            omitted: false
        },
        buttonText: {
            name: "Button text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description:
        "Button to Login or Sign Up for Trello using a third party provider",
    displayField: "entryTitle"
} as const);
